import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import postHelpRequest from 'Api/host-help-partner/postHelpRequest';

import { isArray } from 'lodash';
import { cancelHelpHostText } from 'Const/host-help-partner/domain';

import postHelpRequestPayload from './model/request/postHelpRequestPayload';

const usePostHelpRequest = () => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async ({ studioId, notes }) => {
      onShowLoader({ variant: 'loader-primary' });

      const payload = postHelpRequestPayload({ studioId, notes });

      const result = await postHelpRequest(payload);

      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['help-request-status'] });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : cancelHelpHostText.defaultErrorDesc;

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => onResetLoader(),
  });
};

export default usePostHelpRequest;
